import React from "react";
import { Typography } from "@mui/material";
import { ProductUnion } from "../../../types/ProductUnion";

type InsuranceDataProps = {
  product: ProductUnion;
};

export default function InsuranceData({ product }: InsuranceDataProps) {
  if (!product.caseInsurance.insurer) {
    return null;
  }

  return (
    <Typography>
      {product.caseInsurance.insurer.name || "-"} | Versicherungsnr: {product.caseInsurance.insurancePolicyNumber || "-"} |
      Schadennr: {product.caseInsurance.caseReferenceNumber || "-"}
    </Typography>
  );
}
